module.exports = "../images/icons-race-details/Iscritti.svg";